import styled from 'styled-components'
import CapaRelatorio from '../../../assets/img/testeBandeja/CAPA_EM_BRANCO_BANDEJA.webp'
import SubCapaImg from '../../../assets/img/testeBandeja/imgSubCapaBranca2.webp'

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 10px);
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
`

export const BodyDrawer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .campo__dois__inputs {
    display: flex;
    gap: 10px;
  }

  .header {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    background-color: rgb(224, 224, 224);
  }

  .overlay {
    position: absolute;
    background-color: white;
    width: 100%;
    height: calc(100% - 100px);
  }

  .titulo__resumo {
    height: auto;
    width: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 15px;
    font-size: 12px;
    background-color: #5da57d;
    /* border: thin solid rgba(0, 0, 0, 0.3); */
    margin-top: 10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    h3 {
      color: #ffff;
      margin: 0;
      padding: 0;
    }

    .seta {
      display: inline-block;
      color: white;
      animation: sobeDesceResumo 1s ease-in-out infinite;
    }

    @keyframes sobeDesceResumo {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-4px); /* sobe */
      }
      100% {
        transform: translateY(0); /* volta pro centro */
      }
    }
  }
`

export const HeaderRelatorio = styled.div`
  display: flex;
  justify-content: space-between;

  .campo__taxa__cv {
    display: flex;
    border-radius: 5px;
    padding: 10px;
  }

  .campo__faixa {
    display: flex;
    padding: 10px;
  }
`
export const Tratores = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;


  .container__tratores {
    display: flex;
    width: 90%;
    justify-content: space-around;
  
    margin-left: 20px;
  }

  .trator__direito {
    width: 30%;
    display: flex;

    align-items: center;
    justify-content: center;
  }

  .trator__esquerdo {
    width: 24%;
     margin-left: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seta {
    display: inline-block;
    color: red;
    animation: sobeDesce 1s ease-in-out infinite;
  }

  @keyframes sobeDesce {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px); /* sobe */
    }
    100% {
      transform: translateY(0); /* volta pro centro */
    }
  }
`
export const PdfPrintRelatorio = styled.div`
  display: flex;
  flex-direction: column;
  font-variant: normal;
  width: 210mm;
  gap: 10px;
  position: relative;

  .teste_ {
    width: 210mm;
    height: 297mm;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    opacity: 0;
  }

  .pagina-a4 {
    display: flex;
    position: relative;
    flex-direction: column;
    gap: 17px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    padding: 10px;
    opacity: 1;
  }

  .pagina__a4__window {
    display: flex;
    flex-direction: column;
    gap: 15px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    padding: 10px;
  }

  .teste_:is([data-view='false']) {
    display: none;
  }
  .teste_:is([data-view='true']) {
    display: flex;
  }

  .titulo__grafico {
    display: flex;
    justify-content: center;
    padding: 10px;
  }

  .teste {
    background-color: white;
    opacity: 1;
    width: 100%;
    height: calc(100vh - 195px);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .rodape {
    position: absolute;
    bottom: 0px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    min-width: 100%;

    .texto {
      font-size: 10px;
      margin: 0 0 0 10px;
    }
  }

  .gradiente {
    width: 95%;
    min-height: 6px;
    background-image: linear-gradient(to right, #00770e, #ffffff);
    margin-bottom: 5px;
  }

  @media print {
    .teste_ {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      page-break-after: always;
      opacity: 1;
    }

    .pagina-a4 {
      width: 190mm !important;
      height: 250mm !important;
      padding: 5mm !important;
      border: 2px solid #e0e0e0 !important;
      box-sizing: border-box !important;
      margin: 40px 0px 0px 0px !important;
      /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); */
      page-break-after: always !important;
      opacity: 1 !important;
      position: relative;
      .teste__bar {
        height: 250px !important;
        width: 100% !important;
      }
    }

    .pagina__a4__window {
      display: none !important;
    }

    body {
      margin: 0;
    }
  }
`
export const PdfPrintResumo = styled.div`
  display: flex;
  flex-direction: column;
  font-variant: normal;
  width: 100%;
  height: 100%;

  @media print {
    width: 210mm !important;
    height: auto !important;
    min-height: 297mm !important;
    padding: 5mm !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: none !important;
    background: white !important;
    page-break-after: always !important;
  }

  body {
    margin: 0;
  }
`
export const Capa = styled.div`
  position: relative;
  background-image: url(${CapaRelatorio});
  background-size: cover;
  position: relative;
  overflow: hidden;
  display: flex;
  width: 210mm;
  height: 297mm;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 210px;
  border: 1px solid #e0e0e0;

  div.title {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
    padding-right: 50px;
    /* background-color: red; */
    h2 {
      font-size: 25px;
      color: #00a8b9;
      flex: 2;
      margin-top: 500px;
      margin-bottom: 0;
      font-weight: 700;
      font-family: 'Calibri' !important;
    }

    span {
      font-size: 18px;
      color: #6b6c6f;
      font-weight: 700;
      font-family: 'Calibri' !important;
    }
  }

  div.title__primary {
    width: 85%;
    box-sizing: border-box;
    padding: 50px;
    display: flex;
    flex-direction: column;
    align-items: end;
    padding-right: 50px;
    border-top: 1px solid #162b42;
    border-bottom: 1px solid #162b42;
    /* background-color: red; */

    h1 {
      gap: 5px;
    }

    h2 {
      font-size: 25px;
      color: #00a8b9;
      flex: 2;
      margin-top: 500px;
      margin-bottom: 0;
      font-weight: 700;
      font-family: 'Calibri' !important;
    }

    span {
      font-size: 18px;
      color: #6b6c6f;
      font-weight: 700;
      font-family: 'Calibri' !important;
    }
  }

  img.Capa__logo {
    max-height: 90px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    height: 100vh;
    /* background-size: contain; */
    div.title {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: end;
      padding-right: 50px;
      /* background-color: red; */
      h2 {
        font-size: 12px;
        color: #00a8b9;
        flex: 2;
        margin-top: 100px;
        margin-bottom: 0;
        font-weight: 700;
        font-family: 'Calibri' !important;
      }

      span {
        font-size: 12px;
        color: #6b6c6f;
        font-weight: 700;
        font-family: 'Calibri' !important;
      }
    }

    div.footer {
      margin-right: 21px !important;
      div {
        img {
          width: 140px !important;
        }
        span {
        }
      }
      span {
      }
    }
  }

  div.footer {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 35%;
    flex-direction: column;
    justify-content: center;
    align-self: flex-end;
    padding-right: 25px;
    margin-bottom: 25px;
    div {
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        width: 225px;
      }
      span {
        font-size: 13px;
        font-weight: 500;
      }
    }
    span {
      font-size: 22px;
    }
  }
`
export const SubCapa = styled.div`
  position: relative;
  background-image: url(${SubCapaImg});
  background-size: cover;
  position: relative;
  overflow: hidden;
  display: flex;
  width: 210mm;
  height: 297mm;
  justify-content: start;
  padding: 50px 30px 50px 30px;
  align-items: center;
  flex-direction: column;
  border: 1px solid #e0e0e0;
`

export const Sumario = styled.div`
  position: relative;
  display: flex;
  position: relative;
  align-items: center;
  padding-top: 25px;
  box-sizing: border-box;
  padding: 40px;
  /* overflow: hidden; */
  font-size: 12px;
  gap: 15px;
  flex-direction: column;
  width: 210mm;
  height: auto;
  min-height: 297mm;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1px solid #e0e0e0;

  @media print {
    height: auto !important;
    width: 210mm !important;
    min-height: 297mm !important;
    padding: 5mm !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: none !important;
    background: white !important;
    page-break-after: always !important;

    span.Sumario__referencia {
      width: 190mm !important;
    }
  }

  span.Sumario__referencia {
    position: inherit;
    width: 100%;
    height: 100%;
    display: inherit;
    align-items: inherit;
    padding-top: inherit;
    overflow: inherit;
    font-size: inherit;
    gap: inherit;
    flex-direction: inherit;
  }

  ul.ul-secundaria {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    list-style: none;
    padding-left: 10px;

    .force_margen_sumario {
      display: none;
    }

    @media print {
      .force_margen_sumario {
        display: block;
      }
    }

    li.li-secundaria {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      div.div-secundaria {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        z-index: 10;
        div {
          z-index: 10;
          background-color: #fff;
          a {
            color: #000;
            text-decoration: none;

            transition: 0.2s;
            &:hover {
              font-weight: 500;
            }
          }
        }

        &::before {
          z-index: 9;
          content: '';
          width: 95%;
          position: absolute;
          left: -20px;
          top: 0;
          bottom: 3px;
          margin-left: 35px;
          border-bottom: 1px dashed #ccc;
        }
      }
    }
  }
`
export const ResumoTesteBandeja = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 5px;
  gap: 10px;
  flex-direction: column;
  width: 100%;
  height: auto;
  border: 1px solid #e0e0e0;
  overflow: hidden;

  .titulo__resumo__imprimir {
    height: auto;
    width: 164.2mm;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 13px;
    font-size: 14px;
    background-color: #5da57d;
    /* border: thin solid rgba(0, 0, 0, 0.3); */
     border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    h3 {
      color: #ffff;
      margin: 0;
      padding: 0;
    }

    .seta {
      display: inline-block;
      color: white;
    }
  }

  @media print {
    width: 210mm !important;
    height: auto !important;
    min-height: 297mm !important;
    padding: 3mm !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: none !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  div.div-table {
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #ccc;
    table {
      font-family: 'Calibri';
      thead,
      tbody,
      th,
      td {
        padding: 12px;
      }

      tbody {
        tr {
          th {
            display: flex;
            flex-direction: column;
            small {
              color: #959595;
            }
          }
        }
      }

      thead {
        tr {
          th {
            font-weight: 700;
            border-left: 1px solid #ccc;

            &:first-child {
              border-left: none;
            }
          }
        }
      }

      th {
        background-color: #f1f1f1;
      }
      td {
        text-align: center;
      }
    }
  }

  .rodapeResumo {
    position: absolute;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    min-width: 100%;
  }
`
export const TrReverse = styled.tr`
  position: relative;

  th {
    text-align: left;
    font-weight: 600;
    border-top: 1px solid #ccc;
  }
  td {
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    overflow: hidden;

    div {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 5px;
      align-items: center;
      div.circle {
        width: 10px;
        height: 10px;
        border: 1px solid #d8d8d8;
        border-radius: 50%;
      }
    }
  }
`
